export const LANG_KEY = "ipm-lang";
export const PAYMENT_AGE = "payment-age";

const getCookie = (cname: string): string => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");

  for (let c of ca) {
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const setCookie = (cname: string, value: any, exdays: number = 90): void => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${value};${expires};path=/`;
};

const clearCookie = (cname: string): void => {
  document.cookie = `${cname}=;${new Date(2018)};path=/`;
};

export default {
  getCookie,
  setCookie,
  clearCookie
};
